import React from "react";

const Header = () => {
  return (
    <div className="ui-fixed-menu">
      <div className="uicontainercenter">
        <br/>
      <h2 className="h-2"> Welcome to FaKeShOp </h2>
        <br/>

       
      </div>
     
    </div>
  );
};

export default Header;
